module.exports = __webpack_public_path__ + "img/signup-bg6.10101d3a.png";